import { apiInterfaceForJson } from '../common/apiManager';

export const getAllResultsData = (params = {}) => {
    return apiInterfaceForJson('/order/v1/all_results', 'POST', params);
};

export const updateResultValue = (payload) => {
    return apiInterfaceForJson('/order/v1/update_result', 'POST', payload);
};
